module.exports = __webpack_public_path__ + "static/img/y4.b9c81f45.jpg";